import { documentToReactComponents, Options } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'
import { options } from '@/services/ContentfulService'

interface ContentfulRichTextProps {
  className?: string
  json?: Document
  renderOptionOverrides?: (options: Options) => Options
}

export const ContentfulRichText: React.VFC<ContentfulRichTextProps> = ({
  className,
  json,
  renderOptionOverrides = (options) => options,
}) => {
  if (!json) return null

  return <div className={className}>{documentToReactComponents(json, renderOptionOverrides(options))}</div>
}
